module.exports = __webpack_public_path__ + "6b9ac18650543b1e2c9adbd39eed6dd2.svg";